import React, { useEffect, useState } from 'react';
import smartLabLogo from '@assets/logo/smartLab_logo(color_horizontal).png';
import kisLogo from '@assets/logo/kisPayment_logo(horizontal).png';
import mainIconColor from '@assets/icon/main_icon(color).png';
import totalIconColor from '@assets/icon/total_icon(color).png';
import perMachineColor from '@assets/icon/perMachine_icon(color).png';
import chargeColor from '@assets/icon/charge_icon(color).png';
import gearColor from '@assets/icon/gear(color).png';
import storeColor from '@assets/icon/store_icon(color).png';
import ringColor from '@assets/icon/ring_icon(color).png';
import { useLocation, Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { AUTH } from '@dataTypes/authTypes';
import { getNoticeAccess } from '@apis/notification';
import { getStoreAdminAccess } from '@apis/storeAdmin';

const DashBoardLeftNavBar = () => {
  const location = useLocation();
  const authority = Cookies.get('smartlab_authority');
  const userType = Cookies.get('userType');
  const [canWriteNotice, setCanWriteNotice] = useState(authority === AUTH.MASTER);
  const [canManageStore, setCanManageStore] = useState(authority === AUTH.MASTER);

  useEffect(() => {
    getNoticeAccess()
      .then((access) => setCanWriteNotice(access.canWrite || access.canGrant))
      .catch(() => setCanWriteNotice(authority === AUTH.MASTER));
    getStoreAdminAccess()
      .then((access) => setCanManageStore(!!access.canRead))
      .catch(() => setCanManageStore(authority === AUTH.MASTER));
  }, [authority]);

  const [navActive, setNavActive] = useState({
    main: true,
    total: false,
    perMachine: false,
    charge: false,
    grant: false,
    addStore: false,
    notification: false,
  });

  useEffect(() => {
    const path = location.pathname;

    if (path.includes('/admin/permachine')) {
      setNavActive({
        main: false,
        total: false,
        perMachine: true,
        charge: false,
        grant: false,
        addStore: false,
        notification: false,
      });
    } else if (path.includes('/admin/total')) {
      setNavActive({
        main: false,
        total: true,
        perMachine: false,
        charge: false,
        grant: false,
        addStore: false,
        notification: false,
      });
    } else if (path.includes('/admin/charge')) {
      setNavActive({
        main: false,
        total: false,
        perMachine: false,
        charge: true,
        grant: false,
        addStore: false,
        notification: false,
      });
    } else if (path.includes('/admin/grant')) {
      setNavActive({
        main: false,
        total: false,
        perMachine: false,
        charge: false,
        grant: true,
        addStore: false,
        notification: false,
      });
    } else if (path.includes('/admin/addstore')) {
      setNavActive({
        main: false,
        total: false,
        perMachine: false,
        charge: false,
        grant: false,
        addStore: true,
        notification: false,
      });
    } else if (path.includes('/admin/notification')) {
      setNavActive({
        main: false,
        total: false,
        perMachine: false,
        charge: false,
        grant: false,
        addStore: false,
        notification: true,
      });
    } else {
      setNavActive({
        main: true,
        total: false,
        perMachine: false,
        charge: false,
        grant: false,
        addStore: false,
        notification: false,
      });
    }
  }, [location.pathname]);

  return (
    <div className="dashboard_left_nav_bar">
      <section className="main_section">
        {userType === 'kis' ? (
          <img className="main_img" src={kisLogo} alt="메인이미지" />
        ) : (
          <img className="main_img" src={smartLabLogo} alt="메인이미지" />
        )}
      </section>

      <ul className="nav_lists">
        <li className={`nav_item ${navActive.main ? 'active' : ''}`}>
          <Link to="/admin/dashboard" className="nav_link">
            <div className="nav_cover">
              <img className="nav_icon" alt="메인 화면 아이콘" src={mainIconColor} />
              <div className="title">메인화면</div>
            </div>
          </Link>
        </li>

        <li className={`nav_item ${navActive.total ? 'active' : ''}`}>
          <Link to="/admin/totalsales" className="nav_link">
            <div className="nav_cover">
              <img className="nav_icon" alt="통합 매출 아이콘" src={totalIconColor} />
              <div className="title">통합매출</div>
            </div>
          </Link>
        </li>

        <li className={`nav_item ${navActive.perMachine ? 'active' : ''}`}>
          <Link to="/admin/permachine" className="nav_link">
            <div className="nav_cover">
              <img className="nav_icon" alt="단말기별 조회 아이콘" src={perMachineColor} />
              <div className="title">단말기조회</div>
            </div>
          </Link>
        </li>

        {authority !== AUTH.USER && (
          <li className={`nav_item ${navActive.grant ? 'active' : ''}`}>
            <Link to={`/admin/grant`} className="nav_link">
              <div className="nav_cover">
                <img className="nav_icon" alt="관리자 권한 조회 아이콘" src={gearColor} />
                <div className="title">관리자</div>
              </div>
            </Link>
          </li>
        )}

        <li className={`nav_item ${navActive.charge ? 'active' : ''}`}>
          <Link to="/admin/charge" className="nav_link">
            <div className="nav_cover">
              <img className="nav_icon" alt="수수료 조회 아이콘" src={chargeColor} />
              <div className="title">수수료 조회</div>
            </div>
          </Link>
        </li>

        {canManageStore && (
          <li className={`nav_item ${navActive.addStore ? 'active' : ''}`}>
            <Link to="/admin/addstore" className="nav_link">
              <div className="nav_cover">
                <img className="nav_icon" alt="상점관리 아이콘" src={storeColor} />
                <div className="title">상점관리</div>
              </div>
            </Link>
          </li>
        )}

        {canWriteNotice && (
          <li className={`nav_item ${navActive.notification ? 'active' : ''}`}>
            <Link to="/admin/notification" className="nav_link">
              <div className="nav_cover">
                <img className="nav_icon" alt="공지사항 관리 아이콘" src={ringColor} />
                <div className="title">공지사항 관리</div>
              </div>
            </Link>
          </li>
        )}

        <li className={`nav_item logout_btn`}>
          <span style={{ margin: '0 auto', textAlign: 'center', width: '100%', display: 'block' }}>
            고객센터 02-2632-6599
          </span>
        </li>
      </ul>
    </div>
  );
};

export default DashBoardLeftNavBar;
